import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Box/Box.js");
